import React, { useEffect, useState } from "react";
import { Newpassword, resetLogin } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { decryptUserId } from "../../utilis/encrypto";
import Logo from "../../assets/images/login/logo.png";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import Grid from "@mui/system/Grid";
import Stack from "@mui/system/Stack";
import AgreeSec from "../agree-sec";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function CreatePassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { newpass } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleChange = (e) => {
    const { name, value } = e.target;

   
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));

   
    if (name === "password") {
      setPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!password) {
      errors.password = "Password is required.";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters long.";
    }

    if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required.";
    } else if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match!";
    }

    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    try {
      const response = await dispatch(
        Newpassword({
          id: userId,
          password,
          confirm_password: confirmPassword,
        })
      );

      if (response?.error) {
        setError({ api: "Failed to update password. Please try again." });
      } else {
        dispatch(resetLogin());
        navigate("/chat");
      }
    } catch (err) {
      console.error("Error:", err);
      setError({ api: "An unexpected error occurred. Please try again." });
    }
  };

  useEffect(() => {
    if (newpass) {
      navigate("/chat");
    }
  }, [navigate, newpass]);
  return (
    <>
      <Box className="login-wrapper">
        <Grid container spacing={2} sx={{ height: "100%" }}>
          <Grid size={6}>
            <Box sx={{ m: "32px 80px" }}>
              <img src={Logo} alt="logo" />
            </Box>
          </Grid>
          <Grid size={6}>
            <Stack
              sx={{
                height: "100%",
                width: "50%",
                margin: "0 auto",
                position: "relative",
              }}
              justifyContent={"start"}
              alignItems={"center"}
            >
              <Box
                sx={{ width: "100%", paddingTop: { xs: "50px", xl: "190px" } }}
              >
                <Typography
                  variant="h1"
                  sx={{ color: "#fff", fontSize: "40px", fontWeight: "700" }}
                  fullWidth
                >
                  Create New Password
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "#CBD2E2",
                    fontSize: "16px",
                    fontWeight: "500",
                    mt: "12px",
                    mb: "28px",
                  }}
                >
                  Create a new password to securely access your account.
                </Typography>
              </Box>

              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ width: "100%" }}
              >
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={handleChange}
                    placeholder="Enter new password"
                    className="custom-input"
                    sx={{ color: "#fff" }}
                    endAdornment={
                      <InputAdornment position="end" sx={{ pr: "16px" }}>
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          sx={{ color: "#fff" }}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>}
                  />
                  {error.password && (
                    <Typography color="error" sx={{ mb: 2 }}>
                      {error.password}
                    </Typography>
                  )}
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <OutlinedInput
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={handleChange}
                    className="custom-input"
                    sx={{ color: "#fff" }}
                    endAdornment={
                      <InputAdornment position="end" sx={{ pr: "16px" }}>
                        <IconButton
                          onClick={handleClickShowConfirmPassword}
                          edge="end"
                          sx={{ color: "#fff" }}
                        >
                          {showConfirmPassword ? <Visibility/> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>}
                  />
                  {error.confirmPassword && (
                    <Typography color="error" sx={{ mb: 2 }}>
                      {error.confirmPassword}
                    </Typography>
                  )}
                </FormControl>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    mb: 2,
                    p: "10px",
                    backgroundColor: "primary.Main",
                    fontSize: "18px",
                    fontWeight: "500",
                    borderRadius: "50px",
                    height: "auto",
                  }}
                >
                  Reset Password
                </Button>
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  bottom: { xs: "4px", xl: "24px" },
                  left: 0,
                  right: 0,
                }}
              >
                <AgreeSec />
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>

      {/* <form onSubmit={handleSubmit}>
        <div>
          <label>New Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            required
          />
        </div>

        <div>
          <label>Confirm Password:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re-enter new password"
            required
          />
        </div>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <button type="submit">Set New Password</button>
      </form> */}
    </>
  );
}

export default CreatePassword;
